import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/usePaginationRule'

import { PaginationRuleModel } from '@models/types'

const generateTabBarItems = (paginationRule: PaginationRuleModel) => {
  const urls = generateUrls(paginationRule)
  const { editPaginationRuleUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editPaginationRuleUrl,
      key: 'details',
      title: paginationRule?.title || 'Pagination Rule Details',
    },
  ]
}

export default generateTabBarItems
